import React, { Component, useEffect, useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Label,
    Input,
    Card,
    CardBody,
    ListGroup,
    ListGroupItem,
    Button,
    Col,
    Row
} from "reactstrap";
import _ from "lodash";
import { useFetch2 } from "components/utils/authenticatedHook";
import Select from "react-select";
import ReactLoading from "react-loading";
import encryptRequest from "../../helpers/encryptationHelper";
import moment from "moment";

function EducationMaterialSendToPatient(props) {
    let [{ response: educationMaterial, error: educationMaterialError, isLoading: educationMaterialLoader }, doFetch] = useFetch2();
    const [{ response: sendMaterial, error: sendMaterialError, isLoading: sendMaterialLoader }, doFetch2] = useFetch2();
    const [{ response: questionnaireDetails, error: questionnaireDetailsError, isLoading: questionnaireDetailsLoader }, doFetch3] = useFetch2();
    let [{ response: createEducationalQuestionnaire, error: createEducationalQuestionnaireError, isLoading: createEducationalQuestionnaireLoader }, doFetch4] = useFetch2();

    const [formData, setFormData] = useState({
        materialType: "",
        message: "",
        patient: props.patientId ? [props.patientId] : [],
    });
    const [formError, setFormError] = useState({});
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [selectedEducationalMaterial, setSelectedEducationalMaterial] = useState(null);
    const [sendQuestionnaire, setSendQuestionnaire] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const selectedQ = questionnaireDetails?.data?.find((q) => q._id === selectedId) || null;

    const customStyles = {
        menu: (base) => ({
            ...base,
            zIndex: 2000,
            position: "absolute",
            maxHeight: "200px",
            overflowY: "auto",
        }),
        menuList: (base) => ({
            ...base,
            maxHeight: "200px",
            overflowY: "auto",
        }),
    };

    async function onSubmit() {
        setFormSubmitted(true)
        const response = await validation();
        if (response && (!sendQuestionnaire || (sendQuestionnaire && selectedQ))) {
            const payload = {
                patient: formData && formData.patient && formData.patient.length > 0 ? formData.patient : [],
                message: formData && formData.message,
                materialType: formData && formData.materialType && formData.materialType._id,
                files: formData && formData.materialType && formData.materialType.files,
                materialLink: formData.materialType && formData.materialType.materialLink && formData.materialType.materialLink.length > 0 ? formData.materialType.materialLink : [],
            }
            doFetch2({
                url: "/education-material-send",
                method: "POST",
                disableWait: true,
                body: payload,
                message: 'Educational material successfully sent to the patient'
            });
            if (sendQuestionnaire && selectedQ) {
                doFetch2({
                    url: `/create-individual-educational-questionnaires/${encryptRequest(props.patientId)}/${encryptRequest(selectedQ._id)}`,
                    method: "POST",
                    disableWait: true,
                    message: 'Questionnaire has been successfully sent to the patient'
                });
            }
        }
    }

    async function validation() {
        if (formData && _.isEmpty(formData.patient)) {
            setFormError({
                type: "patient",
                message: "Please select patient",
            });
            return false;
        }
        if (formData && _.isEmpty(formData.materialType)) {
            setFormError({
                type: "materialType",
                message: "Please select material type",
            });
            return false;
        }
        if (formData && _.isEmpty(formData.materialType.files)) {
            setFormError({
                type: "materialType",
                message: "At least one document file is required. Please select the material type again.",
            });
            return false;
        }
        if (formData && _.isEmpty(formData.message)) {
            setFormError({
                type: "message",
                message: "Please enter message",
            });
            return false;
        }
        if (formData && _.size(formData.message) < 5) {
            setFormError({
                type: "message",
                message: "Message must be 5 character",
            });
            return false;
        }
        setFormError({})
        return true;
    }

    function handleChangeMaterial(event) {
        setSelectedEducationalMaterial(event);
        setFormData((prev) => ({ ...prev, materialType: event }));
        if(sendQuestionnaire){
            getEducationalQuestionnaire(event._id);
        }
    }

    function handleChangeMessage(event) {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    }

    function handleRemove(indexToRemove) {
        const selectedMaterialType = { ...formData.materialType }; // clone the object
        const files = selectedMaterialType.files ? [...selectedMaterialType.files] : []; // clone files array

        selectedMaterialType.files = files.filter((_, index) => index !== indexToRemove);

        setFormData((prev) => ({
            ...prev,
            materialType: selectedMaterialType,
        }));
    }

    useEffect(() => {
        doFetch({
            url: "/get-education-material-type",
            method: "GET",
            disableWait: true,
        });
    }, []);

    useEffect(() => {
        if (!sendMaterialLoader && formSubmitted) {
            setFormSubmitted(false);
            props.toggleModal("reload");
        }
    }, [sendMaterialLoader]);

    useEffect(() => {
        if (formData && formSubmitted) {
            validation()
        }

    }, [formData])

    function handleSendQuestionnaire(event){
      setSendQuestionnaire(event.target.checked)
      if(event.target.checked && selectedEducationalMaterial){
        getEducationalQuestionnaire();
      }
    }
     
    function getEducationalQuestionnaire(materialId = null) {
        doFetch3({
            url: `/get-send-educational-material-questionnaires/${encryptRequest(materialId || selectedEducationalMaterial._id)}`,
            method: "GET",
            disableWait: true,
        });
    } 
    
    return (
        <div>
            <Modal
                isOpen={props.sendModal}
                toggle={props.toggleModal}
                backdrop="static"
                className="bastaLang modal-lg"
                size={"lg"}
            >
                <ModalHeader toggle={props.toggleModal}>
                    Send Educational Material To Patient
                </ModalHeader>

                <ModalBody style={{ backgroundColor: "white" }}>
                    {(educationMaterialLoader || createEducationalQuestionnaire || sendMaterialLoader) ? <div>
                        <ReactLoading
                            type="spin"
                            className="text-center mx-auto"
                            color="blue"
                        />
                    </div> :
                        <Row>
                        <Col md={selectedEducationalMaterial && sendQuestionnaire ? 6 : 12}>
                        <Form>
                            <FormGroup>
                                <Label for="materialType">Select Material Type</Label>
                                <Select
                                    required={true}
                                    value={formData.materialType}
                                    onChange={handleChangeMaterial}
                                    options={
                                        educationMaterial && educationMaterial.educationMaterialType
                                            ? educationMaterial.educationMaterialType
                                            : []
                                    }
                                    isMulti={false}
                                    getOptionLabel={(option) => option["materialType"]}
                                    getOptionValue={(option) => option._id}
                                    styles={customStyles}
                                    name="materialType"
                                />
                                {formError &&
                                    _.size(formError) > 1 &&
                                    formError.type == "materialType" &&
                                    formError.message && (
                                        <Label
                                            className="error-message"
                                            style={{
                                                color: "red",
                                                textAlign: "left",
                                                paddingTop: "3px",
                                            }}
                                        >
                                            {formError.message}
                                        </Label>
                                    )}
                            </FormGroup>
                            {formData && formData.materialType ? (
                                <div>
                                    <h4>Educational Documents</h4>
                                    <ul className="list-unstyled">
                                        {formData.materialType &&
                                            formData.materialType.files.map((file, index) => (
                                                <li
                                                    key={index}
                                                    className="doc-item d-flex align-items-center justify-content-between border-bottom py-2"
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <span className="pdf-icon me-2">
                                                            <i
                                                                className="mdi mdi-file-pdf"
                                                                style={{ fontSize: "25px", color: "red" }}
                                                            />
                                                        </span>
                                                        <a href={process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + file.path} target="_blank" rel="noopener noreferrer">
                                                            <span
                                                                style={{
                                                                    color: "black",
                                                                    textDecoration: "underline",
                                                                    fontWeight: 200
                                                                }}
                                                            > {file.name}
                                                            </span></a>

                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-link"
                                                        style={{ color: "red" }}
                                                        onClick={() => handleRemove(index)}
                                                    >
                                                        <i
                                                            className="mdi mdi-close-circle-outline"
                                                            style={{ fontSize: "20px" }}
                                                        ></i>
                                                    </button>
                                                </li>
                                            ))}
                                    </ul>

                                    {formData.materialType && formData.materialType.materialLink && formData.materialType.materialLink.length > 0 && (<div>
                                        <h4>Educational Material Links</h4>
                                        {formData.materialType.materialLink.map((item, index) => (
                                            <div key={index}>
                                                <a
                                                    href={item} // adjust this to the correct field if necessary
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    <p>
                                                        <i
                                                            className="mdi mdi-link mr-2"
                                                            style={{ fontSize: 20, color: 'blue' }}
                                                        ></i>
                                                        <span
                                                            style={{
                                                                color: "black",
                                                                textDecoration: "underline",
                                                                fontWeight: 200
                                                            }}
                                                        >
                                                            {item}
                                                        </span>
                                                    </p>
                                                </a>
                                            </div>
                                        ))}
                                    </div>)}
                                </div>
                            ) : (
                                ""
                            )}
                            <FormGroup>
                                <Label for="message">Message *</Label>
                                <Input
                                    type="textarea"
                                    className="input-date-filter remove-bottom-margin mb-3"
                                    name="message"
                                    rows={3}
                                    style={{ lineHeight: "1.4", fontSize: "17px" }}
                                    onChange={handleChangeMessage}
                                    value={formData.message}
                                />
                                {formError &&
                                    _.size(formError) > 1 &&
                                    formError.type == "message" &&
                                    formError.message && (
                                        <Label
                                            className="error-message"
                                            style={{
                                                color: "red",
                                                textAlign: "left",
                                            }}
                                        >
                                            {formError.message}
                                        </Label>
                                    )}
                            </FormGroup>
                            <div className="form-check form-check-info">
                            <label className="form-check-label text-dark">
                                <input type="checkbox" className="form-check-input" onClick={(event) => handleSendQuestionnaire(event)}/>
                                 Do you want to send the questionnaire for this educational material?
                                <i className="input-helper" />
                            </label>
                            </div>
                        </Form>
                        </Col>
                        {selectedEducationalMaterial && sendQuestionnaire && (
                        <Col md={6}>
                        {questionnaireDetailsLoader ? <div
                            style={{
                                height: "100%",
                                minHeight: "200px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <div>Please wait, we are fetching questionnaire
                                <span style={{ display: "inline-block", marginLeft: "5px" }}>
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                    <span className="dot">.</span>
                                </span>
                            </div>
                        </div>
                        : <div>
                            <div>
                                {/* Questionnaires Section */}
                                {questionnaireDetails && questionnaireDetails.data?.length > 0 ? (
                                    <div>
                                        <FormGroup>
                                        <Label for="materialType">Select Questionnaire</Label>
                                        <Select
                                            value={questionnaireDetails.data.find(opt => opt._id === selectedId) || null}
                                            onChange={(option) => setSelectedId(option._id)} 
                                            options={questionnaireDetails.data}
                                            getOptionLabel={option => option.name}
                                            getOptionValue={option => option._id}
                                            menuPortalTarget={document.body}
                                            styles={{
                                                menuPortal: base => ({ ...base, zIndex: 9999 })
                                            }}
                                        />
                                        {!selectedQ && sendQuestionnaire && formSubmitted && (
                                            <Label
                                                className="error-message"
                                                style={{
                                                    color: "red",
                                                    textAlign: "left",
                                                    paddingTop: "3px",
                                                }}
                                            >
                                                Please select questionnaire
                                            </Label>
                                        )}
                                        </FormGroup>
                                        {selectedQ && (
                                            <Card className="shadow-sm border-0 rounded-lg mt-3">
                                                <CardBody style={{ padding: "1rem" }}>
                                                    {/* Title */}
                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <h4 className="mb-3 text-info d-flex align-items-center">
                                                            <i className="mdi mdi-frequently-asked-questions mr-2"></i>
                                                            {selectedQ.name}
                                                        </h4>
                                                    </div>
                                                    {/* Meta Info */}
                                                    <ul className="list-unstyled mb-3">
                                                    <li>
                                                        <strong>Created By:</strong>{" "}
                                                        {selectedQ.createdByUser
                                                        ? `${selectedQ.createdByUser.fname} ${selectedQ.createdByUser.lname} (${selectedQ.createdByUser.role})`
                                                        : "-"}
                                                    </li>

                                                    {selectedQ.repeatPer !== "once" && selectedQ.timeDuration !== "noEndDate" && (
                                                        <>
                                                        <li>
                                                            <strong>Start Date:</strong>{" "}
                                                            {moment(selectedQ.startDate).format("MMM DD, YYYY")}
                                                        </li>
                                                        <li>
                                                            <strong>End Date:</strong>{" "}
                                                            {moment(selectedQ.endDate).format("MMM DD, YYYY")}
                                                        </li>
                                                        </>
                                                    )}

                                                    <li>
                                                        <strong>Frequency:</strong>{" "}
                                                        {selectedQ.repeatPer
                                                        ? selectedQ.repeatPer.charAt(0).toUpperCase() +
                                                            selectedQ.repeatPer.slice(1)
                                                        : "-"}
                                                    </li>
                                                    </ul>
                                                    <hr />
                                                    {/* Questions */}
                                                    <h5 className="mt-3 mb-3 text-info">
                                                        <i className="mdi mdi-help-circle-outline mr-2"></i>
                                                        Questions
                                                    </h5>

                                                    {selectedQ.questions?.length > 0 ? (
                                                        <ListGroup flush>
                                                            {selectedQ.questions.map((ques, idx) => (
                                                                <ListGroupItem key={ques._id} className="mb-2 rounded shadow-sm border">
                                                                    <strong className="d-block mb-2">
                                                                        Q{idx + 1}: {ques.question}
                                                                    </strong>

                                                                    {/* Options */}
                                                                    <ul className="mb-2 pl-3">
                                                                        {ques.answers.map((ans, i) => (
                                                                            <li
                                                                                key={i}
                                                                                style={{
                                                                                    color: ans.isCurrectAnswer ? "green" : "inherit",
                                                                                    fontWeight: ans.isCurrectAnswer ? "bold" : "normal",
                                                                                }}
                                                                            >
                                                                                {ans.answer}
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                </ListGroupItem>
                                                            ))}
                                                        </ListGroup>
                                                    ) : (
                                                    <div
                                                        style={{
                                                            height: "100%",
                                                            minHeight: "200px",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    ><p className="text-muted">No questions available.</p>
                                                    </div>
                                                    )}
                                                </CardBody>
                                            </Card>
                                        )}
                                    </div>
                                ) : (
                                <div
                                    style={{
                                        height: "100%",
                                        minHeight: "200px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                > <p className="text-muted">No questionnaire available.</p>
                                </div>
                                )}
                            </div>
                        </div>}
                        </Col>)}
                        <button
                            type="submit"
                            className="btn btn-block btn-gradient-info btn-lg font-weight-medium auth-form-btn mx-3"
                            style={{ color: "white" }}
                            disabled={sendMaterialLoader}
                            onClick={() => onSubmit()}
                        >
                            {sendMaterialLoader ? (
                                <i
                                    className="mdi mdi-loading mdi-spin mr-2"
                                    style={{ fontSize: 17 }}
                                ></i>
                            ) : (
                                <i
                                    className="mdi mdi-send mr-2"
                                    style={{ fontSize: 17 }}
                                ></i>
                            )}
                            {selectedQ && sendQuestionnaire ? "Send Material and Questionnaire" : "Send Material"}
                        </button>
                        </Row>
                        }
                </ModalBody>
            </Modal>
        </div>
    );
}

export default EducationMaterialSendToPatient;
